module.exports = __webpack_public_path__ + "img/60.19e51420.png";